module.exports = __webpack_public_path__ + "static/media/signage-industrial-img17.73a26ec9.jpg";